/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateChallengeDto } from '../model';
// @ts-ignore
import type { CreateChallengeResponseDto } from '../model';
// @ts-ignore
import type { DeleteChallengeResponseDto } from '../model';
// @ts-ignore
import type { GetChallengeByIdResponseDto } from '../model';
// @ts-ignore
import type { GetChallengeResponseDto } from '../model';
// @ts-ignore
import type { PaginatedChallengesResponseDto } from '../model';
// @ts-ignore
import type { UpdateChallengeDto } from '../model';
// @ts-ignore
import type { UpdateChallengeResponseDto } from '../model';
/**
 * ChallengesApi - axios parameter creator
 * @export
 */
export const ChallengesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new challenge with categories
         * @param {CreateChallengeDto} createChallengeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerCreateChallenge: async (createChallengeDto: CreateChallengeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createChallengeDto' is not null or undefined
            assertParamExists('challengesControllerCreateChallenge', 'createChallengeDto', createChallengeDto)
            const localVarPath = `/api/challenges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChallengeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new challenge with file uploads (transaction-safe)
         * @param {File} bannerPhoto Banner photo file (required)
         * @param {string} data JSON stringified CreateChallengeWithFilesDto
         * @param {File} [eBibImage0] E-Bib number image for category 0
         * @param {File} [eCertImage0] E-Certificate image for category 0
         * @param {Array<File>} [finisherShirtImages0] Finisher shirt images for category 0
         * @param {Array<File>} [medalImages0] Medal images for category 0
         * @param {Array<File>} [otherImages] Additional images (up to 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerCreateChallengeWithFiles: async (bannerPhoto: File, data: string, eBibImage0?: File, eCertImage0?: File, finisherShirtImages0?: Array<File>, medalImages0?: Array<File>, otherImages?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bannerPhoto' is not null or undefined
            assertParamExists('challengesControllerCreateChallengeWithFiles', 'bannerPhoto', bannerPhoto)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('challengesControllerCreateChallengeWithFiles', 'data', data)
            const localVarPath = `/api/challenges/with-files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (bannerPhoto !== undefined) { 
                localVarFormParams.append('bannerPhoto', bannerPhoto as any);
            }
    
            if (data !== undefined) { 
                localVarFormParams.append('data', data as any);
            }
    
            if (eBibImage0 !== undefined) { 
                localVarFormParams.append('eBibImage_0', eBibImage0 as any);
            }
    
            if (eCertImage0 !== undefined) { 
                localVarFormParams.append('eCertImage_0', eCertImage0 as any);
            }
                if (finisherShirtImages0) {
                finisherShirtImages0.forEach((element) => {
                    localVarFormParams.append('finisherShirtImages_0', element as any);
                })
            }

                if (medalImages0) {
                medalImages0.forEach((element) => {
                    localVarFormParams.append('medalImages_0', element as any);
                })
            }

                if (otherImages) {
                otherImages.forEach((element) => {
                    localVarFormParams.append('otherImages', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a challenge by ID
         * @param {string} challengeId Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerDeleteChallenge: async (challengeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeId' is not null or undefined
            assertParamExists('challengesControllerDeleteChallenge', 'challengeId', challengeId)
            const localVarPath = `/api/challenges/{challengeId}`
                .replace(`{${"challengeId"}}`, encodeURIComponent(String(challengeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export challenges CSV with optional filters
         * @param {string | null} [search] Search query to filter challenges by title or description
         * @param {boolean | null} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerExportCsv: async (search?: string | null, isActive?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/challenges/export/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all challenges without user participation data
         * @param {string} [shouldPromote] Filter by yarn status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerFindAllChallenges: async (shouldPromote?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/challenges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shouldPromote !== undefined) {
                localVarQueryParameter['shouldPromote'] = shouldPromote;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all challenges with pagination and search
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search query to filter challenges by title or description
         * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerFindAllChallengesPaginated: async (page?: number, limit?: number, search?: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/challenges/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get challenge details by ID with user participation data
         * @param {string} challengeId Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerFindChallengeById: async (challengeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeId' is not null or undefined
            assertParamExists('challengesControllerFindChallengeById', 'challengeId', challengeId)
            const localVarPath = `/api/challenges/{challengeId}`
                .replace(`{${"challengeId"}}`, encodeURIComponent(String(challengeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing challenge with categories
         * @param {string} challengeId Challenge ID
         * @param {UpdateChallengeDto} updateChallengeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerUpdateChallenge: async (challengeId: string, updateChallengeDto: UpdateChallengeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'challengeId' is not null or undefined
            assertParamExists('challengesControllerUpdateChallenge', 'challengeId', challengeId)
            // verify required parameter 'updateChallengeDto' is not null or undefined
            assertParamExists('challengesControllerUpdateChallenge', 'updateChallengeDto', updateChallengeDto)
            const localVarPath = `/api/challenges/{challengeId}`
                .replace(`{${"challengeId"}}`, encodeURIComponent(String(challengeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChallengeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChallengesApi - functional programming interface
 * @export
 */
export const ChallengesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChallengesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new challenge with categories
         * @param {CreateChallengeDto} createChallengeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengesControllerCreateChallenge(createChallengeDto: CreateChallengeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChallengeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengesControllerCreateChallenge(createChallengeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengesApi.challengesControllerCreateChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new challenge with file uploads (transaction-safe)
         * @param {File} bannerPhoto Banner photo file (required)
         * @param {string} data JSON stringified CreateChallengeWithFilesDto
         * @param {File} [eBibImage0] E-Bib number image for category 0
         * @param {File} [eCertImage0] E-Certificate image for category 0
         * @param {Array<File>} [finisherShirtImages0] Finisher shirt images for category 0
         * @param {Array<File>} [medalImages0] Medal images for category 0
         * @param {Array<File>} [otherImages] Additional images (up to 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengesControllerCreateChallengeWithFiles(bannerPhoto: File, data: string, eBibImage0?: File, eCertImage0?: File, finisherShirtImages0?: Array<File>, medalImages0?: Array<File>, otherImages?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateChallengeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengesControllerCreateChallengeWithFiles(bannerPhoto, data, eBibImage0, eCertImage0, finisherShirtImages0, medalImages0, otherImages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengesApi.challengesControllerCreateChallengeWithFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a challenge by ID
         * @param {string} challengeId Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengesControllerDeleteChallenge(challengeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteChallengeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengesControllerDeleteChallenge(challengeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengesApi.challengesControllerDeleteChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export challenges CSV with optional filters
         * @param {string | null} [search] Search query to filter challenges by title or description
         * @param {boolean | null} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengesControllerExportCsv(search?: string | null, isActive?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengesControllerExportCsv(search, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengesApi.challengesControllerExportCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all challenges without user participation data
         * @param {string} [shouldPromote] Filter by yarn status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengesControllerFindAllChallenges(shouldPromote?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetChallengeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengesControllerFindAllChallenges(shouldPromote, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengesApi.challengesControllerFindAllChallenges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all challenges with pagination and search
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search query to filter challenges by title or description
         * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengesControllerFindAllChallengesPaginated(page?: number, limit?: number, search?: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedChallengesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengesControllerFindAllChallengesPaginated(page, limit, search, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengesApi.challengesControllerFindAllChallengesPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get challenge details by ID with user participation data
         * @param {string} challengeId Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengesControllerFindChallengeById(challengeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChallengeByIdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengesControllerFindChallengeById(challengeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengesApi.challengesControllerFindChallengeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing challenge with categories
         * @param {string} challengeId Challenge ID
         * @param {UpdateChallengeDto} updateChallengeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async challengesControllerUpdateChallenge(challengeId: string, updateChallengeDto: UpdateChallengeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateChallengeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.challengesControllerUpdateChallenge(challengeId, updateChallengeDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChallengesApi.challengesControllerUpdateChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChallengesApi - factory interface
 * @export
 */
export const ChallengesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChallengesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new challenge with categories
         * @param {CreateChallengeDto} createChallengeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerCreateChallenge(createChallengeDto: CreateChallengeDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateChallengeResponseDto> {
            return localVarFp.challengesControllerCreateChallenge(createChallengeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new challenge with file uploads (transaction-safe)
         * @param {File} bannerPhoto Banner photo file (required)
         * @param {string} data JSON stringified CreateChallengeWithFilesDto
         * @param {File} [eBibImage0] E-Bib number image for category 0
         * @param {File} [eCertImage0] E-Certificate image for category 0
         * @param {Array<File>} [finisherShirtImages0] Finisher shirt images for category 0
         * @param {Array<File>} [medalImages0] Medal images for category 0
         * @param {Array<File>} [otherImages] Additional images (up to 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerCreateChallengeWithFiles(bannerPhoto: File, data: string, eBibImage0?: File, eCertImage0?: File, finisherShirtImages0?: Array<File>, medalImages0?: Array<File>, otherImages?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<CreateChallengeResponseDto> {
            return localVarFp.challengesControllerCreateChallengeWithFiles(bannerPhoto, data, eBibImage0, eCertImage0, finisherShirtImages0, medalImages0, otherImages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a challenge by ID
         * @param {string} challengeId Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerDeleteChallenge(challengeId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteChallengeResponseDto> {
            return localVarFp.challengesControllerDeleteChallenge(challengeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export challenges CSV with optional filters
         * @param {string | null} [search] Search query to filter challenges by title or description
         * @param {boolean | null} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerExportCsv(search?: string | null, isActive?: boolean | null, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.challengesControllerExportCsv(search, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all challenges without user participation data
         * @param {string} [shouldPromote] Filter by yarn status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerFindAllChallenges(shouldPromote?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetChallengeResponseDto>> {
            return localVarFp.challengesControllerFindAllChallenges(shouldPromote, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all challenges with pagination and search
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search query to filter challenges by title or description
         * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerFindAllChallengesPaginated(page?: number, limit?: number, search?: string, isActive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedChallengesResponseDto> {
            return localVarFp.challengesControllerFindAllChallengesPaginated(page, limit, search, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get challenge details by ID with user participation data
         * @param {string} challengeId Challenge ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerFindChallengeById(challengeId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetChallengeByIdResponseDto> {
            return localVarFp.challengesControllerFindChallengeById(challengeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing challenge with categories
         * @param {string} challengeId Challenge ID
         * @param {UpdateChallengeDto} updateChallengeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        challengesControllerUpdateChallenge(challengeId: string, updateChallengeDto: UpdateChallengeDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateChallengeResponseDto> {
            return localVarFp.challengesControllerUpdateChallenge(challengeId, updateChallengeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChallengesApi - object-oriented interface
 * @export
 * @class ChallengesApi
 * @extends {BaseAPI}
 */
export class ChallengesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new challenge with categories
     * @param {CreateChallengeDto} createChallengeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    public challengesControllerCreateChallenge(createChallengeDto: CreateChallengeDto, options?: RawAxiosRequestConfig) {
        return ChallengesApiFp(this.configuration).challengesControllerCreateChallenge(createChallengeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new challenge with file uploads (transaction-safe)
     * @param {File} bannerPhoto Banner photo file (required)
     * @param {string} data JSON stringified CreateChallengeWithFilesDto
     * @param {File} [eBibImage0] E-Bib number image for category 0
     * @param {File} [eCertImage0] E-Certificate image for category 0
     * @param {Array<File>} [finisherShirtImages0] Finisher shirt images for category 0
     * @param {Array<File>} [medalImages0] Medal images for category 0
     * @param {Array<File>} [otherImages] Additional images (up to 10)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    public challengesControllerCreateChallengeWithFiles(bannerPhoto: File, data: string, eBibImage0?: File, eCertImage0?: File, finisherShirtImages0?: Array<File>, medalImages0?: Array<File>, otherImages?: Array<File>, options?: RawAxiosRequestConfig) {
        return ChallengesApiFp(this.configuration).challengesControllerCreateChallengeWithFiles(bannerPhoto, data, eBibImage0, eCertImage0, finisherShirtImages0, medalImages0, otherImages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a challenge by ID
     * @param {string} challengeId Challenge ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    public challengesControllerDeleteChallenge(challengeId: string, options?: RawAxiosRequestConfig) {
        return ChallengesApiFp(this.configuration).challengesControllerDeleteChallenge(challengeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export challenges CSV with optional filters
     * @param {string | null} [search] Search query to filter challenges by title or description
     * @param {boolean | null} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    public challengesControllerExportCsv(search?: string | null, isActive?: boolean | null, options?: RawAxiosRequestConfig) {
        return ChallengesApiFp(this.configuration).challengesControllerExportCsv(search, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all challenges without user participation data
     * @param {string} [shouldPromote] Filter by yarn status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    public challengesControllerFindAllChallenges(shouldPromote?: string, options?: RawAxiosRequestConfig) {
        return ChallengesApiFp(this.configuration).challengesControllerFindAllChallenges(shouldPromote, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all challenges with pagination and search
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Number of items per page (default: 10, max: 100)
     * @param {string} [search] Search query to filter challenges by title or description
     * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    public challengesControllerFindAllChallengesPaginated(page?: number, limit?: number, search?: string, isActive?: boolean, options?: RawAxiosRequestConfig) {
        return ChallengesApiFp(this.configuration).challengesControllerFindAllChallengesPaginated(page, limit, search, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get challenge details by ID with user participation data
     * @param {string} challengeId Challenge ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    public challengesControllerFindChallengeById(challengeId: string, options?: RawAxiosRequestConfig) {
        return ChallengesApiFp(this.configuration).challengesControllerFindChallengeById(challengeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing challenge with categories
     * @param {string} challengeId Challenge ID
     * @param {UpdateChallengeDto} updateChallengeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApi
     */
    public challengesControllerUpdateChallenge(challengeId: string, updateChallengeDto: UpdateChallengeDto, options?: RawAxiosRequestConfig) {
        return ChallengesApiFp(this.configuration).challengesControllerUpdateChallenge(challengeId, updateChallengeDto, options).then((request) => request(this.axios, this.basePath));
    }
}

